import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '0.75rem',

    '& h3': {
      fontFamily: 'Sora',
      fontWeight: '600',
      fontSize: '1.25rem',
      lineHeight: '2rem',
      color: '#191C1A',
      margin: 0,
      padding: '0rem 0.015rem',
    },
  },

  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
  },

  item: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    width: 'clamp(11.75rem,11.75rem,11.75rem) !important',

    '& span': {
      fontFamily: 'Nunito',
      fontWeight: '500',
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
      color: '#8B8D97',
    },

    '& strong': {
      fontFamily: 'Sora',
      fontWeight: '600',
      fontSize: '1.25rem',
      lineHeight: '2rem',
      color: '#191C1A',
    },
  },
}))

export { useStyles }
